import { Component, OnInit, inject } from '@angular/core';
import { ChipComponent } from '@forgerock/backstage-ui-components';
import type { KeyOfType } from '@forgerock/backstage-ui-core';
import { ProductTreePath } from '@forgerock/backstage-ui-core';
import { AppSearchParamsInt } from '../../model/app-search-params';
import { Tab, tabLookup } from '../../model/tabs';
import { EntityTypePipe } from '../../pipe/entity-type.pipe';
import { LibraryNamePipe } from '../../pipe/library-name.pipe';
import { ProductVersionPathPipe } from '../../pipe/product-version-path.pipe';
import { SourcePipe } from '../../pipe/source.pipe';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';
import { SearchParamsMapperService } from '../search-params-mapper.service';

@Component({
  selector: 'app-search-filter-chips',
  templateUrl: './search-filter-chips.component.html',
  styleUrls: [ './search-filter-chips.component.scss' ],
  imports: [ SourcePipe, LibraryNamePipe, EntityTypePipe, ProductVersionPathPipe, ChipComponent ]
})
export class SearchFilterChipsComponent implements OnInit {
  private container = inject(SearchParamsContainerComponent);
  private mapper = inject(SearchParamsMapperService);

  params: Partial<AppSearchParamsInt>;
  hasChips = false;
  tabLookup = tabLookup;

  ngOnInit(): void {
    this.container.paramsChange.subscribe({
      next: params => {
        this.params = this.mapper.filterParamsForTab(params);
        this.hasChips = this.params?.tab !== tabLookup.all
          || !!this.params?.source?.length
          || !!this.params?.entityType?.length
          || !!this.params?.publicationType?.length
          || !!this.params?.tags?.length
          || !!this.params?.library?.length
          || !!this.params?.status?.length
          || !!this.params?.priority?.length
          || !!this.params?.productVersionPath?.length;
      }
    });
  }

  removeParam(key: KeyOfType<AppSearchParamsInt, string[]>, value: string): void {
    this.container.setParams({
      [ key ]: this.params[ key ].filter(it => it !== value)
    });
  }

  removeProductVersionPathParams(path: ProductTreePath): void {
    this.container.setParams({
      productVersionPath: this.params.productVersionPath.filter(it => it.toString() !== path.toString())
    });
  }

  setTab(tab: Tab): void {
    this.container.setParams({ tab });
  }

}
